var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0213D2E9-2408-4BDA-B9BD-3DBAF681A3DA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-get-in-touch",
    transform: "translate(-751, -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size=24-2",
    transform: "translate(751, 520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09816091,19.4701645 L11.8070311,16.6299117 L16.5158714,19.5075363 L15.2826037,14.1260045 L19.4308678,10.5383166 L13.9745925,10.0524839 L11.8070311,4.96992611 L9.63946971,10.0151122 L4.18316453,10.5009449 L8.33142862,14.1260045 L7.09816091,19.4701645 Z M11.8070311,19.2659653 L5.99138911,22.7732292 C5.77484225,22.8996952 5.55780208,22.9527631 5.3402985,22.9327318 C5.12277998,22.912551 4.92584581,22.8393024 4.7495259,22.7128364 C4.57323589,22.5863704 4.43717283,22.4210378 4.34135166,22.2169881 C4.24551555,22.0127888 4.23017819,21.787213 4.29535452,21.5399615 L5.83906186,14.9366725 L0.704781555,10.4922746 C0.513139228,10.3255966 0.390978457,10.1324595 0.338284291,9.91316203 C0.285590126,9.69371512 0.299477467,9.48039718 0.379946316,9.27350718 C0.460445063,9.0664677 0.576402124,8.89739791 0.727802552,8.76614832 C0.879217928,8.63474926 1.08619762,8.54909321 1.34874163,8.50873172 L8.12449377,7.91661374 L10.7549417,1.68128698 C10.8507628,1.44940275 10.9959147,1.27788137 11.1903973,1.1667079 C11.3848799,1.05556432 11.5904245,1 11.8070311,1 C12.0234883,1 12.2290329,1.05556432 12.423665,1.1667079 C12.6181476,1.27788137 12.7632994,1.44940275 12.8591206,1.68128698 L15.4894937,7.91661374 L22.2652907,8.50873172 C22.5277899,8.54909321 22.7348294,8.63474926 22.8862597,8.76614832 C23.0375405,8.89739791 23.1535425,9.0664677 23.2341159,9.27350718 C23.3145399,9.48039718 23.3284422,9.69371512 23.2756733,9.91316203 C23.2230539,10.1324595 23.100923,10.3255966 22.9092807,10.4922746 L17.7750004,14.9366725 L19.3186031,21.5399615 C19.3837794,21.787213 19.3685318,22.0127888 19.2727106,22.2169881 C19.1768894,22.4210378 19.0407068,22.5863704 18.8644616,22.7128364 C18.6882164,22.8393024 18.4911926,22.912551 18.273689,22.9327318 C18.0561854,22.9527631 17.8391303,22.8996952 17.6226732,22.7732292 L11.8070311,19.2659653 Z",
    id: "Shape",
    fill: "#CEFAB7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOpen);
export default __webpack_public_path__ + "static/media/star-open.9deace4601d672bdab8a3b3b1773c38e.svg";
export { ForwardRef as ReactComponent };